import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Routes,
} from '@angular/router';
import {
  requireAuthenticated,
  requireNotAuthenticated,
} from '@app/shared/auth/guards';
import { withScreenConfig } from './core/screen/config';
import { HomePageComponent } from './pages/home/home.component';
import { StartPageComponent } from './pages/start/start.component';
import { DebugPageComponent } from './pages/debug/debug.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: HomePageComponent,
    title: 'ホーム',
    canActivate: [() => requireAuthenticated()],
  },
  {
    path: 'question',
    loadChildren: () => import('./pages/question/routes').then((m) => m.routes),
    canActivate: [
      (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
        requireAuthenticated(state.url),
    ],
  },
  {
    // TODO: `/question` に移行する前の古いパス。頃合いを見て削除する
    path: 'preview/question',
    redirectTo: 'question/preview',
  },
  {
    // TODO: `/question` に移行する前の古いパス。頃合いを見て削除する
    path: 'admin',
    children: [
      {
        path: 'question-attributes',
        redirectTo: '/question/upload',
      },
      {
        path: 'sections',
        redirectTo: '/question/contents',
      },
    ],
  },
  {
    path: 'test',
    loadChildren: () => import('./pages/test/routes').then((m) => m.routes),
    canActivate: [
      (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
        requireAuthenticated(state.url),
    ],
  },
  {
    path: 'manage',
    loadChildren: () => import('./pages/manage/routes').then((m) => m.routes),
    canActivate: [
      (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
        requireAuthenticated(state.url),
    ],
  },
  {
    path: 'start',
    component: StartPageComponent,
    title: 'スタート',
    // canActivateではなくcanMatchを使うことで、ログイン後には `/start` というルートが存在しないことになる。
    // これにより、下のフォールバックルートにて 'start' へのリダイレクトができず、'' へリダイレクトする
    canMatch: [() => requireNotAuthenticated()],
    data: { ...withScreenConfig({ hideSidenav: true }) },
  },
  {
    path: 'debug',
    component: DebugPageComponent,
    title: '開発用',
  },
  {
    path: 'video',
    loadChildren: () => import('./pages/video/routes').then((m) => m.routes),
    canActivate: [
      (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
        requireAuthenticated(state.url),
    ],
  },
  {
    path: '**',
    redirectTo: 'start',
  },
  {
    path: '**',
    redirectTo: '',
  },
];
